var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection-modal"},[_c('div',{staticClass:"collection-modal__wrap"},[_c('h2',{staticClass:"collection-modal__header"},[_vm._t("header")],2),_vm._t("body"),_c('div',{staticClass:"collection-modal__footer"},[_vm._t("footer")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }